export const ADMIN_ROLES = ['ROLE_ADMIN', 'ROLE_ADMIN_SUPER', 'ROLE_ADMIN_USER', 'ROLE_ADMIN_MANAGER'];
export const ROLE_COMPANY_ADMIN = 'ROLE_COMPANY_ADMIN';
export const ROLE_COMPANY_USER = 'ROLE_COMPANY_USER';

export const CLIENT_ID = '9014718a-55c4-4e06-834d-ff88fe357bdb';

export const LANGUAGES_LIST = [
  {
    id: 1,
    code: 'en',
    name: 'English'
  },
  {
    id: 2,
    code: 'ru',
    name: 'Русский'
  },
  {
    id: 3,
    code: 'ja',
    name: '日本語'
  }
];

export const METRICS = {
  // googleId: {
  //   ru: 'UA-114470241-5',
  //   ai: 'UA-114470241-6',
  //   registration_ru: 'UA-114470241-1',
  //   registration_en: 'UA-114470241-2'
  // },
  yandexId: {
    ru: '81472837',
    ai: '54240379',
    registration_ru: '81472837',
    registration_en: '54240262'
  },
  facebookId: {
    registration_ru: '422239101976024'
  }
};

export const HIDDEN_SMS_COUNTRIES = [
  {
    code: 'US',
    title: 'United States'
  },
  {
    code: 'AT',
    title: 'Austria'
  },
  {
    code: 'BE',
    title: 'Belgium'
  },
  {
    code: 'BG',
    title: 'Bulgaria'
  },
  {
    code: 'GB',
    title: 'United Kingdom'
  },
  {
    code: 'HU',
    title: 'Hungary'
  },
  {
    code: 'DE',
    title: 'Germany'
  },
  {
    code: 'GR',
    title: 'Greece'
  },
  {
    code: 'DK',
    title: 'Denmark'
  },
  {
    code: 'IE',
    title: 'Ireland'
  },
  {
    code: 'ES',
    title: 'Spain'
  },
  {
    code: 'IT',
    title: 'Italy'
  },
  {
    code: 'CY',
    title: 'Cyprus'
  },
  {
    code: 'LV',
    title: 'Latvia'
  },
  {
    code: 'LT',
    title: 'Lithuania'
  },
  {
    code: 'LU',
    title: 'Luxembourg'
  },
  {
    code: 'MT',
    title: 'Malta'
  },
  {
    code: 'NL',
    title: 'Netherlands'
  },
  {
    code: 'PL',
    title: 'Poland'
  },
  {
    code: 'PT',
    title: 'Portugal'
  },
  {
    code: 'RO',
    title: 'Romania'
  },
  {
    code: 'SK',
    title: 'Slovakia'
  },
  {
    code: 'SI',
    title: 'Slovenia'
  },
  {
    code: 'FI',
    title: 'Finland'
  },
  {
    code: 'FR',
    title: 'France'
  },
  {
    code: 'HR',
    title: 'Croatia'
  },
  {
    code: 'CZ',
    title: 'Czech Republic'
  },
  {
    code: 'SE',
    title: 'Sweden'
  },
  {
    code: 'EE',
    title: 'Estonia'
  }
];

export const COOKIES_NOT_REMOVABLE = ['viewed_cookie_policy', 'PHPSESSID'];
